'use strict';

var React = require('react');
var component = require('../../Button/component.js');
var cellActions_styles = require('./cellActions.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function isCustomAction(action) {
    return action.render !== undefined;
}
const CellActions = React__default.default.forwardRef(({ actions, ...props }, ref) => (React__default.default.createElement(cellActions_styles.CellActionsStyled, { ...props, ref: ref }, actions.map(action => (React__default.default.createElement(cellActions_styles.ActionSpacing, { key: action.icon }, isCustomAction(action) ? (action.render(action)) : (React__default.default.createElement(component.Button, { onFocus: e => e.stopPropagation(), variant: "secondary", size: "m", ...action }))))))));

exports.CellActions = CellActions;
//# sourceMappingURL=cellActions.js.map
